var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-process-card',{key:_vm.token,staticClass:"mt-5",attrs:{"token":_vm.token,"suffix":_vm.suffix}})}
var staticRenderFns = []

export { render, staticRenderFns }